/* eslint '@typescript-eslint/member-ordering': [
      'warn',
      {
        default: {
          order: 'alphabetically-case-insensitive',
        },
      },
    ], */
import * as editorCapabilitiesConstants from './constants';

/** Union of all built-in insert capability constants */

/** Union of all insert capability types (built-in and custom) */

/**
 * Type guard to check if a capability is a custom insert capability.
 * Custom capabilities are identified by the "CUSTOM_" prefix.
 */
export function isCustomCapability(capability) {
  return typeof capability === 'string' && capability.startsWith('CUSTOM_');
}

/**
 * Type guard to check if a capability is any type of insert capability
 * (either built-in or custom).
 */
export function isInsertCapability(capability) {
  return capability === editorCapabilitiesConstants.DOCUMENTS || capability === editorCapabilitiesConstants.MEETINGS || capability === editorCapabilitiesConstants.SNIPPETS || capability === editorCapabilitiesConstants.QUOTES || capability === editorCapabilitiesConstants.KNOWLEDGE_ARTICLE || capability === editorCapabilitiesConstants.VIDEO_INSERTION || capability === editorCapabilitiesConstants.TEMPLATES || capability === editorCapabilitiesConstants.PAYMENT_LINK || capability === editorCapabilitiesConstants.INVOICES || capability === editorCapabilitiesConstants.SIGNATURE || isCustomCapability(capability);
}

// =============================================================================
// Capability Options Types
// =============================================================================

/** Empty configuration type for capabilities that have no options */
// =============================================================================
// Main EditorConfig Type
// =============================================================================
export default editorCapabilitiesConstants;

/** Union of all editor capability constant values */

/**
 * Main configuration object for the ProseMirror editor.
 * Each key corresponds to a capability that can be enabled and configured.
 * Omitting a key disables that capability.
 */